import { useConfig } from '@chainlit/react-client';

const useLayoutMaxWidth = () => {
  const { config } = useConfig();
  // A 7-column table does not fit in 60rem, let alone 48rem. The wide layout
  // gets the room; in the default layout the table keeps its own horizontal
  // scroll and its pinned label column, which stays readable but is not the
  // designed experience — tenants that show tables should run 'wide'.
  return config?.ui.layout === 'wide'
    ? 'min(64rem, 100vw)'
    : 'min(48rem, 100vw)';
};

export { useLayoutMaxWidth };
